// Add your custom JS here!!!
jQuery(document).ready(function(){
    // Target the parent menu item by class name and add a click event
    jQuery('.ccp-active').on('click', function(){
        // Replace 'your-link-url' with the URL you want to navigate to
        window.location.href = '/control-panels/';
    });
});

jQuery(document).ready(function () {
    jQuery('.dropdown').hover(function () {
        jQuery(this).addClass('show');
        jQuery(this).find('.dropdown-menu').addClass('show');
    }, function () {
       jQuery(this).removeClass('show');
        jQuery(this).find('.dropdown-menu').removeClass('show');
    });
}); 